import { useState, type ReactNode } from 'react';

import { Aviso, Campo, Painel } from '../../comum';
import type { PropsSecao } from './comum';

/**
 * Saída para a internet — a lista de hosts é allowlist, não bloqueio.
 */
export function SecaoRede({ c, podeEditar, acao, salvar }: PropsSecao): ReactNode {
  const [rede, setRede] = useState({
    saidaPermitida: c.rede.saidaPermitida,
    hosts: c.rede.hostsPermitidos.join('\n'),
  });

  return (
    <Painel
      titulo="Rede"
      sub="Para onde este produto pode falar, além do KACE. É a resposta à pergunta que o time de segurança do cliente sempre faz."
    >
      <label style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
        <input
          type="checkbox"
          checked={rede.saidaPermitida}
          disabled={!podeEditar}
          onChange={(e) => setRede({ ...rede, saidaPermitida: e.target.checked })}
        />
        <span>
          <strong>Permitir saída para fora da rede interna</strong>
          <span className="ajuda">
            Desligado, o produto só alcança endereços internos. A conexão com o KACE nunca passa por
            aqui — ela é interna por definição.
          </span>
        </span>
      </label>

      <Campo
        rotulo="Hosts aprovados"
        ajuda="Um por linha, só o host. Aceita curinga de subdomínio: *.atlassian.net"
      >
        <textarea
          rows={5}
          disabled={!podeEditar || !rede.saidaPermitida}
          value={rede.hosts}
          placeholder={'empresa.atlassian.net\nsmtp.empresa.com.br'}
          onChange={(e) => setRede({ ...rede, hosts: e.target.value })}
        />
      </Campo>

      <Aviso>
        Um destino fora desta lista é recusado <strong>antes</strong> de a requisição sair, com o
        host escrito na mensagem — pronto para você levar ao time que responde pelo firewall.
      </Aviso>

      <button
        className="primario"
        disabled={acao.executando || !podeEditar}
        onClick={() =>
          salvar(
            'rede',
            {
              saidaPermitida: rede.saidaPermitida,
              hostsPermitidos: rede.hosts
                .split('\n')
                .map((x: string) => x.trim())
                .filter((x: string) => x !== ''),
            },
            'Rede',
          )
        }
      >
        Salvar
      </button>
    </Painel>
  );
}
